<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_MainOrderRegistr')"
    width="900px"
    :close-on-click-modal="false"
  >
    <div style="display: flex;flex-direction: column;">
      <div style="display: flex;">
        <el-button
          :disabled="!selectedRow"
          type="primary"
          no="1"
          @click="lookHandler"
        >{{ $t('common.btn.look') }}</el-button>
        <el-button type="primary" no="2" @click="newHandler">{{ $t('common.btn.new') }}</el-button>
        <el-button
          :disabled="!selectedRow"
          type="primary"
          no="3"
          @click="deleteHandler"
        >{{ $t('SeaExport.Delete') }}</el-button>
      </div>
      <el-form :label-width="$selectByLang('100px', '110px')" :inline="true" label-position="left" style="margin-top: 5px;">
        <el-form-item :label="$t('SeaExport.AirlineCompany')">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            filterable
            :default-value="filter.airCmpId||''"
            style="width: 190px;"
            no="4"
            @parentCallBack="p=>{filter.airCmpId=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.BookingAgent')">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{bookingAgent:true}"
            filterable
            :default-value="filter.bookingAgentId||''"
            style="width: 190px;"
            no="5"
            @parentCallBack="p=>{filter.bookingAgentId=p.value}"
          />
        </el-form-item>
      </el-form>
      <el-form :label-width="$selectByLang('100px', '110px')" :inline="true" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_RegisteredDate')">
          <el-date-picker
            v-model="filter.startInputDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 190px;"
            no="6"
          />
        </el-form-item>
        <el-form-item :label="$t('Message.ShowFromTo2')">
          <el-date-picker
            v-model="filter.endInputDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 190px;"
            no="7"
          />
        </el-form-item>
        <el-button type="primary" no="8" @click="queryHandler">{{ $t('SeaExport.Query') }}</el-button>
      </el-form>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="min-height: 400px"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer">
      <el-button no="9" @click="innerVisible=false">{{ $t('Message.Close') }}</el-button>
    </span>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="mawbDialog.visible"
      :title="mawbDialog.title"
      :width="$selectByLang('370px', '435px')"
      :close-on-click-modal="false"
      append-to-body
      class="mawb-dialog"
    >
      <el-form :disabled="Boolean(mawbDialog.form.uuid)" :label-width="$selectByLang('80px', '145px')" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_SequenceNumber')">
          <el-input
            v-model="mawbDialog.form.sequence"
            :disabled="true"
            class="seq-color"
            style="width: 160px;"
            no="10"
          />
          <span class="star">*</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_InvalidDate')">
          <el-date-picker
            v-model="mawbDialog.form.effectDate"
            type="date"
            value-format="yyyy-MM-dd"
            :editable="false"
            :clearable="false"
            style="width: 160px;"
            no="11"
          />
          <span class="star">*</span>
        </el-form-item>
        <el-form-item v-if="mawbDialog.visible" :label="$t('SeaExport.AirlineCompany')">
          <div style="display: flex;">
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{airCmp:true}"
              filterable
              :default-value="mawbDialog.form.carrierId||''"
              style="width: 220px;"
              no="12"
              @parentCallBack="airCompanyChangeHandler"
            />
            <span class="star" style="margin-top: 5px;">*</span>
          </div>
        </el-form-item>
        <el-form-item v-if="mawbDialog.visible" :label="$t('SeaExport.BookingAgent')">
          <cargo-advance-select
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{bookingAgent:true}"
            filterable
            :default-value="mawbDialog.form.bookingAgentId||''"
            style="width: 220px;"
            no="13"
            @parentCallBack="p=>{mawbDialog.form.bookingAgentId=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_MainOrderStart')">
          <el-input
            ref="input1"
            :value="mawbDialog.startNo1"
            style="width: 40px;"
            no="14"
            @input="handleInput(1, $event)"
          />&nbsp;-&nbsp;
          <el-input
            ref="input2"
            :value="mawbDialog.startNo2"
            style="width: 50px;"
            no="15"
            @input="handleInput(2, $event)"
          />&nbsp;
          <el-input
            ref="input3"
            :value="mawbDialog.startNo3"
            style="width: 50px;"
            no="16"
            @input="handleInput(3, $event)"
          />
          <span class="star">*</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_TotalCopies')">
          <el-input-number
            v-model="mawbDialog.form.number"
            :precision="0"
            :min="1"
            :max="9999"
            controls-position="right"
            placeholder="1"
            style="width: 120px;"
            no="17"
          />
          <span class="star">*</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.AdditionalNotes')">
          <el-input
            v-model="mawbDialog.form.remark"
            type="textarea"
            :rows="4"
            style="width: 240px;"
            no="18"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Acquirer')">
          <el-input v-model="mawbDialog.inputByName" :disabled="true" style="width: 160px;" no="20" />
        </el-form-item>
        <el-form-item>
          <span style="color: red;padding-left: 10px;padding-right: 6px;">{{ $t('CargoMsg.AERequiredChecksum') }}</span>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_BatchAdd')">
          <cargo-rich-textarea
            v-model="mawbDialog.form.batchAddNo"
            no="batchAddNo"
            style="height: 150px;"
            :close-on-click-modal="false"
            :warning-count="mawbDialog.warningCount"
            :text-chars="0"
            :disabled="Boolean(mawbDialog.form.uuid)"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
          v-show="!mawbDialog.form.uuid"
          type="primary"
          no="21"
          @click="saveHandler"
        >{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button no="22" @click="mawbDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="$t('Message.SaveFailed')"
        width="300px"
        append-to-body
        :close-on-click-modal="false"
      >
        <span style="color: red;padding-left: 10px;padding-right: 6px;">{{ $t('CargoMsg.CARGO_Not_Met_New_Conditions') }}</span>
        <cargo-rich-textarea
          v-model="advanceTextDialog.value"
          no="textChars"
          :disabled="true"
          style="height: 198px;"
          :close-on-click-modal="false"
        />
        <span slot="footer">
          <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { MAWB } from '@/class/model/booking/MAWB'
import { Company } from '@/class/model/mdm/Company'
import { queryMAWB, addMAWB, deleteMAWB } from '@/api/AirExport/mawb'
import { validateMAWBNums } from '@/api/AirExport/mawbDetail'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'

export default {
  name: 'RegistrationDialog',
  components: { CargoRichTextarea, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      filter: {
        airCmpId: 0,
        bookingAgentId: 0,
        startInputDate: '',
        endInputDate: '',
        branch: 0,
        limit: 30
      },
      rowData: [],
      selectedNode: null,
      mawbDialog: {
        visible: false,
        title: '',
        form: new MAWB().fillDefaultValue().getData(),
        startNo1: '',
        startNo2: '',
        startNo3: '',
        inputByName: '',
        warningCount: -1
      },
      advanceTextDialog: {
        visible: false,
        value: ''
      }
    }
  },
  computed: {
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      TYPE_NAMES,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'sequence',
          width: 60
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgentId',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_MainOrderStart'),
          field: 'startNo',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_TotalCopies'),
          field: 'number',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_RegisteredDate'),
          field: 'inputDate',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Acquirer'),
          field: 'inputBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }
      ],
      gridApi: null
    })
  },
  methods: {
    queryHandler() {
      this.filter.branch = this.$store.getters.currentOfficeId
      queryMAWB(this.filter).then(res => {
        this.rowData = res.data
      })
    },
    lookHandler() {
      this.mawbDialog.title = this.$t('common.btn.look')
      this.mawbDialog.form = this.selectedRow
      if (this.selectedRow.startNo && this.selectedRow.startNo.length === 11) {
        this.mawbDialog.startNo1 = this.selectedRow.startNo.substr(0, 3)
        this.mawbDialog.startNo2 = this.selectedRow.startNo.substr(3, 4)
        this.mawbDialog.startNo3 = this.selectedRow.startNo.substr(7, 4)
      }
      this.mawbDialog.inputByName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.mawbDialog.form.inputBy, 'chineseName')
      this.mawbDialog.visible = true
    },
    newHandler() {
      this.mawbDialog.title = this.$t('common.btn.new')
      this.mawbDialog.form = new MAWB().fillDefaultValue().getData()
      this.mawbDialog.form.sequence = ''
      this.mawbDialog.startNo1 = ''
      this.mawbDialog.startNo2 = ''
      this.mawbDialog.startNo3 = ''
      this.mawbDialog.form.inputBy = this.$store.getters.userInfo.userId
      this.mawbDialog.inputByName = this.$selectByLang(this.$store.getters.userInfo.chineseName, this.$store.getters.userInfo.englishName)
      this.mawbDialog.form.dep = this.$store.getters.currentDeptId
      this.mawbDialog.form.branchId = this.$store.getters.currentOfficeId
      this.mawbDialog.visible = true
    },
    airCompanyChangeHandler(obj) {
      this.mawbDialog.form.carrierId = obj.value
      new Company(obj).getAirlineDetail().then(data => {
        this.mawbDialog.startNo1 = data.mawbprefix
        if (!data.mawbprefix || data.mawbprefix.length !== 3) {
          this.$message.info(this.$t('AirExport.TheTheAirlineIsModify'))
        }
      }).catch(() => {
        this.mawbDialog.startNo1 = ''
      })
    },
    async saveHandler() {
      const form = this.mawbDialog.form
      form.startNo = this.mawbDialog.startNo1 + this.mawbDialog.startNo2 + this.mawbDialog.startNo3
      if (!form.carrierId) {
        this.$message.info(this.$t('AirExport.PleaseSelectAnAirline'))
        return
      }
      if (!form.effectDate) {
        this.$message.info(this.$t('AirExport.PleaseSelectTheExpirationDate'))
        return
      }
      form.number = isNaN(form.number) ? 1 : form.number // 默认值1
      if ((!form.startNo || form.startNo.length === 0) && (!form.batchAddNo || form.batchAddNo.length === 0)) {
        this.$message.info(this.$t('AirExport.AERequiredChecksum'))
        return
      }
      if ((!form.startNo || form.startNo.length === 0) && !form.startNo) {
        this.$message.info(this.$t('AirExport.PleaseStartingMasterBillNumber'))
        return
      }
      const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', form.carrierId)
      const airlineDetail = await new Company(cmp).getAirlineDetail()
      if (!airlineDetail || airlineDetail.mawbprefix !== this.mawbDialog.startNo1) {
        this.$message.info(this.$t('AirExport.TheLegalThereIsAirline'))
        return
      }
      if ((!form.batchAddNo || form.batchAddNo.length === 0) && !AirExportUtils.validateMAWBNum(form.startNo)) {
        this.$message.info(this.$t('AirExport.TheNumberIsNotLegal'))
        return
      }
      const mawbDetailNums = AirExportUtils.generateMAWBNums(form.startNo, form.number)
      let batchAddNos = []
      const errorBatchAddNos = []
      if (form.batchAddNo && form.batchAddNo.length > 0) {
        batchAddNos = form.batchAddNo.split('\n')
        batchAddNos = batchAddNos.filter(item => item !== '')
        batchAddNos = batchAddNos.map(item => item.trim())
        this.mawbDialog.form.batchAddNo = ''
        for (const item of batchAddNos) {
          this.mawbDialog.form.batchAddNo += item
          this.mawbDialog.form.batchAddNo += '\n'
        }
        batchAddNos = batchAddNos.map(item => item.replace('-', ''))
        for (const item of batchAddNos) {
          item.replace('-', '')
          if (item.length > 0 && !AirExportUtils.validateMAWBNum(item)) {
            errorBatchAddNos.push(item)
          }
        }
      }
      if (errorBatchAddNos.length > 0) {
        let result = ''
        for (let i = 0; i < errorBatchAddNos.length; i++) {
          result += errorBatchAddNos[i]
          if (i < errorBatchAddNos.length - 1) {
            result += '\n'
          }
        }
        result.trimEnd()
        this.advanceTextDialog.value = result
        this.advanceTextDialog.visible = true
        return
      }
      if (batchAddNos.length > 0) {
        mawbDetailNums.push(batchAddNos)
      }
      // 判断主单号在数据库中是否已经存在
      const validateRes = await validateMAWBNums({ numList: mawbDetailNums.join(',') })
      if (!validateRes.data) {
        this.$message.info(this.$t('AirExport.TheMasterBillMayExist'))
        return
      }
      // 批量新增的主单号设置为空，方便取消数据库限制
      form.batchAddNo = ''
      await addMAWB({ form: form, numList: mawbDetailNums.join(',') })
      this.queryHandler()
      this.mawbDialog.visible = false
      this.$message.success(this.$t('Message.SaveSuccessfully'))
    },
    deleteHandler() {
      this.$confirm(this.$t('AirExport.ConfirmDeleteTheMasterBill'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deleteMAWB({ mawbUuid: this.selectedRow.uuid }).then(res => {
          this.queryHandler()
        })
      })
    },
    /**
     * 处理输入事件
     * index - 输入框索引（1, 2, 3）
     * value - 输入的值
     */
    handleInput(index, value) {
      // 过滤非数字字符
      const filteredValue = value.replace(/[^\d]/g, '')
      if (!filteredValue) {
        // 如果输入框为空，清空对应的值
        if (index === 1) {
          this.mawbDialog.startNo1 = ''
        } else if (index === 2) {
          this.mawbDialog.startNo2 = ''
        } else if (index === 3) {
          this.mawbDialog.startNo3 = ''
        }
        return
      }

      // 根据索引更新对应的输入框值
      if (index === 1) {
        this.mawbDialog.startNo1 = filteredValue.slice(0, 3)
        if (filteredValue.length > 3) {
          this.mawbDialog.startNo2 = filteredValue.slice(3, 7)
        }
        if (filteredValue.length > 7) {
          this.mawbDialog.startNo3 = filteredValue.slice(7, 11)
        }
      } else if (index === 2) {
        this.mawbDialog.startNo2 = filteredValue.slice(0, 4)
        if (filteredValue.length > 4) {
          this.mawbDialog.startNo3 = filteredValue.slice(4, 8)
        }
      } else if (index === 3) {
        this.mawbDialog.startNo3 = filteredValue.slice(0, 4)
      }

      this.focusNextInput(index, filteredValue.length) // 手动输入，按原有逻辑跳转焦点
    },
    /**
     * 自动跳转到下一个输入框
     * currentIndex - 当前输入框索引
     * inputLength - 输入内容的长度
     */
    focusNextInput(currentIndex, inputLength) {
      // 如果是手动输入，仅在输入内容超过最大长度时跳转焦点
      if (currentIndex === 1 && inputLength > 3) {
        this.$refs.input2.focus() // 如果第一个输入框内容超过 3 位，焦点移动到第二个输入框
        if (this.mawbDialog.startNo2.length === 4) {
          this.$refs.input3.focus()// 如果第二个输入框长度为4，焦点移动到第三个输入框
        }
      } if (currentIndex === 2 && inputLength > 4) {
        this.$refs.input3.focus() // 如果第二个输入框内容超过 4 位，焦点移动到第三个输入框
      } if (currentIndex === 3 && inputLength > 4) {
        this.$refs.input3.focus() // 如果第三个输入框内容超过 4 位，焦点仍然停留在第三个输入框
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mawb-dialog ::v-deep {
  .seq-color.el-input {
    .el-input__inner {
      background: #ffffcc !important;
    }
  }
  .el-input-number {
    .el-input__inner {
      text-align: right;
    }
  }
  .highlight {
    color: red;
  }
}
.star {
  display: inline-block;
  height: 20px;
  margin-left: 5px;
  vertical-align: middle;
  font-size: 20px;
}
</style>
